import React from 'react'
import './NotFound.css'


import notfoundimg from '../../images/404_3@2x.png';
// 404_3.svg


const NotFound = ()=>{
    return <div className="notfound-page">
        <img src={notfoundimg}/>
        <div className="notfound-title">Page Not Found</div>
        <div className="notfound-body">It looks like the page you are looking for cannot be found.</div>
        <div className="notfound-body">Please check the URL and try again.</div>
    </div>
}

export default NotFound
